import { render } from "./ClientDataGraphComponent.vue?vue&type=template&id=309feb53&scoped=true"
import script from "./ClientDataGraphComponent.vue?vue&type=script&lang=js"
export * from "./ClientDataGraphComponent.vue?vue&type=script&lang=js"

import "./ClientDataGraphComponent.vue?vue&type=style&index=0&id=309feb53&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309feb53"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QIcon,QBtn,QExpansionItem,QSelect,QTooltip,QInput,QPopupProxy,QDate,QOptionGroup,QTabPanels,QTabPanel});
